
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"27","height":"27","viewBox":"0 0 27 27","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M12.757 2.22065C13.1601 1.3466 14.4024 1.3466 14.8055 2.22065L17.2463 7.51218C17.4106 7.86841 17.7482 8.11369 18.1378 8.15988L23.9245 8.846C24.8804 8.95933 25.2643 10.1408 24.5576 10.7943L20.2793 14.7508C19.9913 15.0171 19.8623 15.414 19.9388 15.7988L21.0744 21.5143C21.262 22.4584 20.257 23.1886 19.4171 22.7185L14.3322 19.8722C13.9899 19.6805 13.5726 19.6805 13.2303 19.8722L8.1454 22.7185C7.30548 23.1886 6.30047 22.4584 6.48806 21.5143L7.62374 15.7988C7.7002 15.414 7.57125 15.0171 7.28323 14.7508L3.00492 10.7943C2.29823 10.1408 2.6821 8.95933 3.63796 8.846L9.42474 8.15988C9.81431 8.11369 10.1519 7.86841 10.3162 7.51218L12.757 2.22065Z","fill":"currentColor"}})])
          )
        }
      }
    